module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_3.83d08f4e.png";